import React from 'react';
import Nav from "./nav";
import Footer from "./footer";
import "../css/planYourTrip.css";
import venue_image_1 from "../images/accomadations/Mietah_Seperepere_Convetion_centre1.jpg";
import Nare from "../images/accomadations/Nare.jpg";
import proteaHotel from "../images/accomadations/protea-hotel.jpg";
import KimberleyAnne from "../images/accomadations/kimberley-anne-hotel-exterior.jpg";
import halfWayHouse from "../images/accomadations/images.jpg";
import Bighole from '../images/bighole.jpeg'
import { Link } from "react-router-dom";
import heroBackground from "../images/IMG_3288.JPG";
import { FiMapPin, FiWifi, FiCoffee, FiDroplet, FiStar, FiChevronRight } from "react-icons/fi";

const PlanYourTrip = () => {
  return (
    <div className="plan-your-trip-page">
       <Nav />
      {/* Hero Section with Parallax Effect */}
      <div className="PlanTriphero-section" >
      <div className="hero-overlay"></div>
      <div className="particles">
          {[...Array(15)].map((_, i) => (
            <div
              key={i}
              className="particle"
              style={{
                width: `${Math.random() * 5 + 2}px`,
                height: `${Math.random() * 5 + 2}px`,
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100 + 100}%`,
                animationDuration: `${Math.random() * 20 + 10}s`,
                animationDelay: `${Math.random() * 5}s`,
              }}
            />
          ))}
        </div>
        <div className="hero-content">
          <div className="hero-text">
            <h1>Plan your EnergyX Africa 2026 Trip.</h1>
            <p className="hero-subtitle">
            Your Gateway to EnergyX Africa 2026
          </p>
            <a href="#discoverourcity">
          <button className="cta-button">Discover Our City</button>
 
          </a>
            <p className="hero-subtitle"></p>
            <div className="scroll-indicator">
            <span></span>
          </div>
          </div>
        </div>
      </div>

      {/* Convention Center Section */}
      <section className="section-venue">
        <div className="container">
          <div className="section-header">
            
            
           
          </div>
          <div className="venue-grid">
            <div className="venue-image-container">
              <img 
                src={venue_image_1} 
                alt="Mittah Seperepere Convention Centre" 
                className="venue-image"
                loading="lazy"
              />
              <div className="image-overlay"></div>
            </div>
            <div className="venue-content">
              <h3>The official venue for 2025  EneryX Africa Conference and Exhibition </h3>
              <p className="venue-description">
                The Mittah Seperepere Convention Centre (MSCC) combines cutting-edge technology with exceptional service to deliver an unparalleled conference experience in the Northern Cape.
              </p>
              <ul className="feature-list">
                <li><FiChevronRight className="feature-icon" /> 2,500 seat amphitheater</li>
                <li><FiChevronRight className="feature-icon" /> 15 flexible meeting rooms</li>
                <li><FiChevronRight className="feature-icon" /> State-of-the-art AV systems</li>
                <li><FiChevronRight className="feature-icon" /> On-site catering services</li>
                <li><FiChevronRight className="feature-icon" /> Secure underground parking</li>
              </ul>
              <div className="action-buttons">
                <Link 
                  to="https://www.google.com/maps/dir//10+W+Circular+Rd,+West+End,+Kimberley,+8301/@-28.7408083,24.6712097,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x1e9b1a568b03f355:0xc570802add5e2cf4!2m2!1d24.7536111!2d-28.7408333?entry=ttu&g_ep=EgoyMDI1MDEyOS4xIKXMDSoJLDEwMjExMjMzSAFQAw%3D%3D"
                  className="btn-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiMapPin /> Get Directions
                </Link>
                
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Host City Section */}
      <section className="section-city bg-light" id="discoverourcity">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Discover Our   Host City : Kimberley
            </h2>
            <div className="divider"></div>
          </div>
          <div className="city-grid">
            <div className="city-content">
              <h3>The Diamond City Awaits</h3>
              <p className="city-description">
                Kimberley offers a unique blend of historical significance and modern amenities, making it the perfect host for EnergyX Africa 2026.
              </p>
              <div className="city-highlights">
                <div className="highlight-card">
                  <div className="highlight-icon">💎</div>
                  <h4>Historical Legacy</h4>
                  <p>Visit the Big Hole, the largest hand-dug excavation in the world</p>
                </div>
                <div className="highlight-card">
                  <div className="highlight-icon">🏨</div>
                  <h4>Modern Comfort</h4>
                  <p>World-class hotels and conference facilities</p>
                </div>
                <div className="highlight-card">
                  <div className="highlight-icon">🌍</div>
                  <h4>Natural Beauty</h4>
                  <p>Gateway to the Northern Cape's stunning landscapes</p>
                </div>
                <div className="highlight-card">
                  <div className="highlight-icon">🍷</div>
                  <h4>Culinary Delights</h4>
                  <p>Experience authentic South African cuisine</p>
                </div>
              </div>
             
            </div>
            <div className="city-image-container">
              <img 
                src={Bighole} 
                alt="Kimberley City" 
                className="city-image"
                loading="lazy"
              />
              <div className="image-caption">
                <span>Kimberley's historic charm meets modern energy</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Accommodation Section */}
      <section className="section-accommodation">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Curated Accommodations
            </h2>
            <div className="divider"></div>
            <p className="section-intro">
              We've partnered with Kimberley's finest hotels and Accomdation spaces to offer exclusive rates for 2025 EnergyX Africa Conference and Exhibition   attendees.
            
            </p>
          </div>

          <div className="accommodation-grid">
            {/* Hotel 1 */}
            <div className="hotel-card">
              <div className="hotel-image-container">
                <img 
                  src={proteaHotel} 
                  alt="Protea Hotel" 
                  className="hotel-image"
                  loading="lazy"
                />
                <div className="hotel-badge">Conference Hotel</div>
                <div className="hotel-rating">
                  <FiStar className="star-icon filled" />
                  <FiStar className="star-icon filled" />
                  <FiStar className="star-icon filled" />
                  <FiStar className="star-icon filled" />
                  <FiStar className="star-icon" />
                  <span>4.8 (124 reviews)</span>
                </div>
              </div>
              <div className="hotel-content">
                <div className="hotel-header">
                  <h3 className="hotel-name">Protea Hotel by Marriott</h3>
                  <div className="hotel-location">
                    <FiMapPin className="location-icon" />
                    <span>1.2km from venue • City Center</span>
                  </div>
                </div>
                
                <div className="hotel-features">
                  <div className="feature">
                    <FiWifi className="feature-icon" />
                    <span>Free WiFi</span>
                  </div>
                  <div className="feature">
                    <FiCoffee className="feature-icon" />
                    <span>Breakfast</span>
                  </div>
                  <div className="feature">
                    <FiDroplet className="feature-icon" />
                    <span>Pool</span>
                  </div>
                </div>
                
                <p className="hotel-description">
                  The premier choice for conference attendees, offering luxury accommodations with direct shuttle service to the convention center.
                </p>
                
               
                
                <div className="hotel-actions">
                 
                  <Link to="https://www.marriott.com/en-us/hotels/kimki-protea-hotel-kimberley/overview/?scid=f2ae0541-1279-4f24-b197-a979c79310b0" className="btn-primary">
                    Book Now
                  </Link>
                </div>
              </div>
            </div>

            {/* Hotel 2 */}
            <div className="hotel-card">
              <div className="hotel-image-container">
                <img 
                  src={Nare} 
                  alt="Nare Boutique Hotel" 
                  className="hotel-image"
                  loading="lazy"
                />
                <div className="hotel-badge">Luxury Boutique</div>
                <div className="hotel-rating">
                  <FiStar className="star-icon filled" />
                  <FiStar className="star-icon filled" />
                  <FiStar className="star-icon filled" />
                  <FiStar className="star-icon filled" />
                  <FiStar className="star-icon filled" />
                  <span>4.9 (87 reviews)</span>
                </div>
              </div>
              <div className="hotel-content">
                <div className="hotel-header">
                  <h3 className="hotel-name">Nare Boutique Hotel</h3>
                  <div className="hotel-location">
                    <FiMapPin className="location-icon" />
                    <span>2.5km from venue • Diamond Hill</span>
                  </div>
                </div>
                
                <div className="hotel-features">
                  <div className="feature">
                    <FiWifi className="feature-icon" />
                    <span>Free WiFi</span>
                  </div>
                  <div className="feature">
                    <FiCoffee className="feature-icon" />
                    <span>Breakfast</span>
                  </div>
                  <div className="feature">
                    <FiDroplet className="feature-icon" />
                    <span>Spa</span>
                  </div>
                </div>
                
                <p className="hotel-description">
                  Experience sophisticated comfort with personalized service in Kimberley's most exclusive boutique hotel.
                </p>
                
                
                
                <div className="hotel-actions">
                  
                  <Link to="https://narehotels.co.za" className="btn-primary" target="_blank">
                    Book Now
                  </Link>
                </div>
              </div>
            </div>


            <div className="hotel-card">
              <div className="hotel-image-container">
                <img 
                  src={KimberleyAnne} 
                  alt="Nare Boutique Hotel" 
                  className="hotel-image"
                  loading="lazy"
                />
                <div className="hotel-badge">Luxury Boutique</div>
                <div className="hotel-rating">
                  <FiStar className="star-icon filled" />
                  <FiStar className="star-icon filled" />
                  <FiStar className="star-icon filled" />
                  <FiStar className="star-icon filled" />
                  <FiStar className="star-icon filled" />
                  <span>4.9 (87 reviews)</span>
                </div>
              </div>
              <div className="hotel-content">
                <div className="hotel-header">
                  <h3 className="hotel-name">Kimberley Anne</h3>
                  <div className="hotel-location">
                    <FiMapPin className="location-icon" />
                    <span>6.5km from venue </span>
                  </div>
                </div>
                
                <div className="hotel-features">
                  <div className="feature">
                    <FiWifi className="feature-icon" />
                    <span>Free WiFi</span>
                  </div>
                  <div className="feature">
                    <FiCoffee className="feature-icon" />
                    <span>Breakfast</span>
                  </div>
                  <div className="feature">
                    <FiDroplet className="feature-icon" />
                    <span>Spa</span>
                  </div>
                </div>
                
                <p className="hotel-description">   
                  The Kimberley Anne experience starts with our 16 luxury rooms where you’ll get the best night’s rest.                </p>

                
                
                
                <div className="hotel-actions">
                  
                  <Link to="https://kimberleyanne.co.za/" className="btn-primary" target="_blank">
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PlanYourTrip;